module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7n8r5r1n-8b0e992dc4fefd1950368ea62bd22f57.svg";